<script setup>
import { ref } from "vue";
import { useRouter, RouterView } from "vue-router";
import PageLoader from "@/components/PageLoader.vue";
// import ChatWidget from "@/components/ChatWidget.vue";

const isAppLoading = ref(!sessionStorage.getItem('loader-shown'));
const router = useRouter();

// Update global state immediately based on initial session check
if (!isAppLoading.value) {
  window.isAppLoaderFinished = true;
}

// Don't show loader if starting on projects page (alternative bypass)
if (window.location.pathname === '/projects') {
  isAppLoading.value = false;
  window.isAppLoaderFinished = true;
}

router.isReady().then(() => {
  // If loader is already disabled via session or initial check, stop here
  if (!isAppLoading.value) return;

  // If we're on projects page, make sure it stays off
  if (router.currentRoute.value.path === '/projects') {
    isAppLoading.value = false;
    window.isAppLoaderFinished = true;
    return;
  }
  
  setTimeout(() => {
    isAppLoading.value = false;
    window.isAppLoaderFinished = true;
    sessionStorage.setItem('loader-shown', 'true');
  }, 4000);
});
</script>

<template>
  <div>
    <Transition name="fade">
      <PageLoader v-show="isAppLoading" />
    </Transition>

    <RouterView />
    <!-- <ChatWidget /> -->
  </div>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.2s ease;
}

.fade-leave-to {
  opacity: 0;
}
</style>


